import { render, staticRenderFns } from "./editPrivateNum.vue?vue&type=template&id=60059a2c&scoped=true&"
import script from "./editPrivateNum.vue?vue&type=script&lang=js&"
export * from "./editPrivateNum.vue?vue&type=script&lang=js&"
import style0 from "./editPrivateNum.vue?vue&type=style&index=0&id=60059a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60059a2c",
  null
  
)

export default component.exports